<template>
  <div class="flex-select flex items-center justify-between">
    <div v-if="options.includes(StoreWidgetV2FlexLayoutEnum.ONE_COLUMN)" class="item" :class="{ 'active': val === StoreWidgetV2FlexLayoutEnum.ONE_COLUMN }" @click="handleSelect('1')">
      <div class="w-[45px] h-[25px] box-color" />
      <div class="text-12 text-center pt-2">单列</div>
    </div>
    <div v-if="options.includes(StoreWidgetV2FlexLayoutEnum.TWO_COLUMN)" class="item" :class="{ 'active': val === StoreWidgetV2FlexLayoutEnum.TWO_COLUMN }" @click="handleSelect('2')">
      <div class="flex gap-1">
        <div class="w-[25px] h-[25px] box-color" />
        <div class="w-[25px] h-[25px] box-color" />
      </div>
      <div class="text-12 text-center pt-2">双列</div>
    </div>
    <div v-if="options.includes(StoreWidgetV2FlexLayoutEnum.ROW_COLUMN)" class="item" :class="{ 'active': val === StoreWidgetV2FlexLayoutEnum.ROW_COLUMN }" @click="handleSelect('3')">
      <div class="flex gap-1">
        <div class="w-[25px] h-[25px] box-color" />
        <div class="w-[25px] h-[25px] box-color" />
        <div class="w-[15px] h-[25px] box-color" />
      </div>
      <div class="text-12 text-center pt-2">横滑</div>
    </div>
  </div>
</template>

<script>
import {StoreWidgetV2FlexLayoutEnum} from "~/enums/layoutEnum";

export default {
  name: 'FlexSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default() {
        return [
          StoreWidgetV2FlexLayoutEnum.ONE_COLUMN,
          StoreWidgetV2FlexLayoutEnum.TWO_COLUMN,
          StoreWidgetV2FlexLayoutEnum.ROW_COLUMN
        ]
      }
    }
  },
  data() {
    return {
      StoreWidgetV2FlexLayoutEnum,
      current: '1',
      val: this.value
    }
  },
  methods: {
    handleSelect(value) {
      this.val = value
      this.$emit('input', this.val)
    }
  }
}
</script>

<style lang="less">
.flex-select {
  gap: 12px;
  overflow-x: auto;
  .item {
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 6px;
    border: 1px solid var(--border-color-base);
    background-color: var(--bg-color-base);
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    .box-color {
      background-color: rgba(255, 255, 255, 0.15);
      border-radius: 2px;
      transition: background-color 0.3s;
    }
    
    .text-center {
        color: var(--text-secondary);
        transition: color 0.3s;
    }
    
    &:hover {
        background-color: var(--bg-color-hover);
        border-color: var(--text-secondary);
        
        .box-color {
            background-color: rgba(255, 255, 255, 0.3);
        }
        
        .text-center {
            color: var(--text-color);
        }
    }
    
    &.active {
      border: 1px solid var(--primary-color);
      background-color: var(--primary-color-alpha-10);
      
      .box-color {
          background-color: var(--primary-color);
          opacity: 0.6;
      }
      
      .text-center {
          color: var(--primary-color);
          font-weight: 500;
      }
    }
  }
}
</style>
